import * as types from '@/store/types'
import constConf from '../../../constconf'
import Vue from 'vue'
import actionRequests from './actionRequests'

export default {
    ...actionRequests
}
